///header Styles dont over ride the things  
import styled from "styled-components";
import tw from "twin.macro";
import { store } from "../../../Redux/store";
import { useLocation } from "react-router";
const primaryFont = "Source Serif Pro, serif";
const secondaryFont = "Hanken Grotesk, sans-serif";

const fontSizes = {
  large: "24px",
  medium: "18px",
  small: "16px",
  semiSmall: "14px",
};
const getOnboardColor = (pathname) =>
  pathname === '/Onboard' ? 'var(--navbar-bg)' : 'var(--onbaord-navbar-bg)';
const bgColors = {
  HomeColor: 'var(----home-navbar-bg)',
  smiOneKudzu: '#30BC89',
  logintextcolor: '#ffffff',
  signUpkudzuPlusTrue: "#779CE5",
};
const isFromSmiOne = store.getState().fromSmiOne;

export const Navbar = styled.header`
  ${tw`sm:h-[100px] h-[90px] text-white sticky top-0 flex justify-between items-center sm:px-[6%] px-[2.5rem] z-50`}
  background-color: ${(props) =>
    props.isFromSmiOne
      ? bgColors.smiOneKudzu
      : props.isOnBoard
        ? getOnboardColor(props.pathname)
        : bgColors.HomeColor};
`;


export const LogoContainer = styled.image`${tw`sm:w-[198px] sm:h-[48px] w-[100px] h-[30px]`}`;

export const LoginButton = styled.button`
  ${tw`sm:w-[162px] sm:block flex items-center justify-end h-[50px] sm:border-[2.5px] font-bold sm:mr-[3%]`};

  font-family: ${(props) =>
    props.isPrimary ? primaryFont : secondaryFont};

  font-size: ${(props) =>
    fontSizes[props.size] || fontSizes.small};

  border-color: ${(props) =>
    props.signUpkudzuPlusTrue
      ? "#779CE5" 
      : props.isFromSmiOne
        ? bgColors.logintextcolor
        : bgColors.smiOneKudzu};

  color: ${(props) =>
    props.isFromSmiOne ? bgColors.logintextcolor : bgColors.smiOneKudzu};
`;

